// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/cover-image/cover-image.scss
// module id = 519
// module chunks = 0